import UploadImage from '@core/components/Upload/UploadImage';
import { Grid } from '@material-ui/core';
import empresaOnboardingApi from 'app/services/api/empresaOnboardngApi';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import { OnboardingContext } from '../OnboardingContext';
import OnboardingLayout from '../OnboardingLayout';
import InformativoLateral from './InformativoLateral';

const LogomarcaOnboarding = () => {
  const [empresa] = useContext(GlobalContext).empresa;
  const [, setLoading] = useContext(OnboardingContext).loading;
  const [, setAtualizarEtapa] = useContext(OnboardingContext).atualizarEtapa;
  const [steps, setSteps] = useContext(OnboardingContext).steps;

  const salvaTelaSemAnexarLogomarca = (possuiAnexo) => {
    if (!possuiAnexo) {
      steps.forEach((step) => {
        if (step.value === 'LOGOMARCA') {
          step.pularEtapa = true;
        }
      });
      setSteps(steps);
    }
  };

  const avancar = async () => {
    try {
      setLoading(true);

      const empresaRequest = empresa;
      const requestObject = { empresaRequest };

      salvaTelaSemAnexarLogomarca(empresa.logomarcaId);

      let resp = await empresaOnboardingApi.atualizar(empresa.id, 'LOGOMARCA', requestObject);
      if (resp.data) {
        setAtualizarEtapa(true);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <OnboardingLayout
      wizardStep={1}
      onSubmit={avancar}
      leftSidebarContent={
        <InformativoLateral titulo="Sua empresa" subTitulo="Logomarca" imagem="assets/images/onboarding/2.svg">
          A marca é muito importante para que os seus clientes reconheçam a personalidade da sua empresa.
          <br />
          <br />
          <div style={{ fontWeight: 'bold', color: '#2e62b8' }}>
            A sua logomarca estará presente em notas fiscais, relatórios e boletos bancários.
          </div>
        </InformativoLateral>
      }
      content={
        <>
          <br />
          <Grid container>
            <Grid item lg={2} md={2} sm={2} xs={2} />
            <Grid item lg={8} md={8} sm={8} xs={8}>
              <UploadImage />
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2} />
          </Grid>
        </>
      }
    />
  );
};

export default LogomarcaOnboarding;
